/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import buildGetURL from "../../../utility/urlHelper";
import { APIGateways } from "../../../utility/APIGateways";
import { LANGUAGE_MAXLENGTH, NAMESPACE_MAXLENGTH } from "../../../utility/constants";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";

const COMPONENT_NAME = "Admin promptsManager/utility/validationHelper";

const fetchPromptUtil = async (action, prompt) => {
	let valid = false;

	try {
		const url = buildGetURL(APIGateways.promptUtilEndpoint, {
			action,
			prompt,
		});

		const result = await fetch(url, { headers: await getAuthHeader() });
		const response = await result.json();

		valid = response.valid;
	} catch (error) {
		v2.verbose("Error while checking if prompt is valid", {
			additionalData: { error: errorToObject(error), data: { action, prompt } },
			componentName: COMPONENT_NAME,
		});
	}

	return valid;
};

const isARN = (prompt) => {
	const arnPattern =
		/^arn:(aws[a-zA-Z-]*){1}:connect:[a-z]{2}-[a-z]+-\d{1}:\d{12}:instance\/[a-z0-9-]{36}\/prompt\/[a-z0-9-]{36}$/;
	let valid = false;

	try {
		if (arnPattern.test(prompt)) {
			valid = true;
		}
	} catch (error) {
		v2.verbose("Error while validating prompt arn", {
			additionalData: { error: errorToObject(error), data: { prompt } },
			componentName: COMPONENT_NAME,
		});
	}

	return valid;
};

export const isValidLanguage = (language) => {
	const pattern = new RegExp(`^[a-z]{${LANGUAGE_MAXLENGTH}}$`);
	//  const pattern = /^[a-z]{2}$/;
	let valid = false;

	try {
		if (pattern.test(language)) {
			valid = true;
		}
	} catch (error) {
		v2.verbose("Error while validating prompt language", {
			additionalData: { error: errorToObject(error), data: { language } },
			componentName: COMPONENT_NAME,
		});
	}

	return valid;
};

export const isValidNamespace = (namespace) => {
	const maxlength = NAMESPACE_MAXLENGTH - 1;
	const pattern = new RegExp(`^[a-zA-Z][a-zA-Z0-9]{0,${maxlength}}$`);
	//  const pattern = /^[a-zA-Z][a-zA-Z0-9]*$/;
	let valid = false;

	try {
		if (pattern.test(namespace)) {
			valid = true;
		}
	} catch (error) {
		v2.verbose("Error while validating prompt namespace", {
			additionalData: { error: errorToObject(error), data: { namespace } },
			componentName: COMPONENT_NAME,
		});
	}

	return valid;
};

export const isValidPromptId = (promptId) => {
	const pattern = /^[a-zA-Z][a-zA-Z0-9_]*$/;
	let valid = false;

	try {
		if (pattern.test(promptId)) {
			valid = true;
		}
	} catch (error) {
		v2.verbose("Error while validating prompt id", {
			additionalData: { error: errorToObject(error), data: { promptId } },
			componentName: COMPONENT_NAME,
		});
	}

	return valid;
};

export const isValidPrompt = async (type, prompt) => {
	let valid = false;

	switch (type) {
		case "TTS":
			valid = true;
			break;
		case "SSML":
			valid = await fetchPromptUtil("isSSML", prompt);
			break;
		case "audio":
			valid = isARN(prompt);
			break;
		default:
			valid = false;
	}

	return valid;
};
